import React from "react"
import { graphql, StaticQuery } from "gatsby"
import CompanyContact from "./CompanyContact"
import Img from "gatsby-image"

class FooterTemplate extends React.Component {
  render() {
    const { data, title, isMobile } = this.props
    const { edges: images } = data.allFile

    return (
      <footer id="footer">
        <div className="content">
          <div className="inner">
            <section className="about">
              <h3>Accreditations</h3>
              <p>We are proud to be accredited by a number of trade bodies.</p>
              <div class="box alt">
                <div class="row gtr-uniform gtr-50">
                  {images &&
                    images.map(({ node: image }) => (
                      <div
                        key={image.name}
                        className={isMobile ? "col-4" : "col-3"}
                      >
                        <span className="image">
                          <Img
                            fixed={image.childImageSharp.fixed}
                            alt={image.name}
                            title={image.name}
                          />
                        </span>
                      </div>
                    ))}
                </div>
              </div>
            </section>
            <CompanyContact />
          </div>
        </div>
        <p className="copyright">
          &copy; {title}. | Website by{" "}
          <a href="https://vacantmind.tech">VacantMind</a>{" "}
        </p>
      </footer>
    )
  }
}

const Footer = ({ title, isMobile }) => {
  return (
    <StaticQuery
      query={graphql`
        query AccreditationImagesQuery {
          allFile(
            filter: {
              extension: { in: ["jpg", "png"] }
              relativeDirectory: { eq: "accreditations" }
            }
          ) {
            edges {
              node {
                name
                relativePath
                childImageSharp {
                  # Specify the image processing specifications right in the query.
                  # Makes it trivial to update as your page's design changes.
                  fixed(height: 50) {
                    ...GatsbyImageSharpFixed
                  }
                }
              }
            }
          }
        }
      `}
      render={data => (
        <FooterTemplate data={data} title={title} isMobile={isMobile} />
      )}
    />
  )
}

export default Footer
